export default "__VITE_ASSET__3dfadaa8__"